/**
 * Tracking Status Constants
 * Matches the C# backend enum implementation
 */
export const TrackingStatus = {
  New: 1,
  ReNew: 2,
  Processing: 3,
  ProcessedWithError: 4,
  ProcessedSuccessfully: 5,
  ReadyToSendToNozzle: 6,
  Enqueued: 7,
  DeletedFromNozzle: 8,
  RevisionRequested: 9,
  Declined: 10,
  DeclinedSuccessfully: 11
};

export default TrackingStatus; 